module.exports = __webpack_public_path__ + "static/media/logo-lorri.a48cab77.png";